import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  // No `withCredentials` — we authenticate via Bearer token in the
  // Authorization header (see interceptor below). Setting withCredentials
  // forces the browser to treat every call as a credentialed request,
  // which iOS Safari rejects when the server responds with
  // `Access-Control-Allow-Origin: *`, leaving the deck empty.
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qd_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export function fileUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) {
    return pathOrUrl;
  }
  if (pathOrUrl.startsWith("/api/")) {
    return `${BACKEND_URL}${pathOrUrl}`;
  }
  return pathOrUrl;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
